import * as Yup from "yup";

const NotificationSchema = Yup.object().shape({
  title: Yup.string().required("Please enter notification title"),
  message: Yup.string().required("Please enter notification message"),
});

export default NotificationSchema;
